const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- calendar-answer ---
let __fez_component_0;
{
const ANSWERS = [
  { id: 'accepted', label: 'Accept', icon: 'check' },
  { id: 'tentative', label: 'Maybe', icon: 'question' },
  { id: 'declined', label: 'Decline', icon: 'x' },
]
__fez_component_0 = class {
  PROPS = {
    event: { type: String, required: true },
    calendar: String,
    partstat: String,
    on_answered: { type: Function, state: true, default: () => {} },
  }

  init() {
    this.state.busy = ''
    this.state.noting = false
  }

  addNote() {
    this.state.noting = true
  }

  async answer(id) {
    const form = this.root.querySelector('form')
    const note = (this.formData(form).note || '').trim()
    this.state.busy = id
    try {
      const view = await window.App.api('calendar/event_answer', { event: this.props.event, calendar: this.props.calendar || undefined, answer: id, note: note || undefined })
      this.state.noting = false
      await this.state.on_answered(view)
    } finally {
      this.state.busy = ''
    }
  }

  beforeRender() {
    this.state.answers = ANSWERS.map((answer) => ({ ...answer, current: answer.id === this.props.partstat }))
    this.state.prompt = ANSWERS.some((answer) => answer.id === this.props.partstat) ? 'Your answer' : 'Going?'
  }

  CSS = `:fez {
display:block;.ans{display:grid;gap:var(--space-2)}.ans-row{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-2)}.ans-prompt{margin-right:var(--space-1);font-size:var(--text-sm);font-weight:var(--weight-semibold)}.ans-note{max-width:420px}
}`

  HTML = `<form class="ans" onsubmit="event.preventDefault()" novalidate>
<div class="ans-row">
<span class="ans-prompt">{state.prompt}</span>
{#each state.answers as answer}
<ui-button size="sm" variant={answer.current ? 'primary' : 'secondary'} icon={answer.icon} label={answer.label} loading={state.busy === answer.id} onclick="fez.answer('{answer.id}')"></ui-button>
{/each}
{#unless state.noting}
<ui-button size="sm" variant="ghost" icon="note-pencil" label="Add a note" onclick="fez.addNote()"></ui-button>
{/unless}
</div>
{#if state.noting}
<div class="ans-note"><ui-input name="note" placeholder="A note to the organizer (optional)" maxlength="1000" autofocus></ui-input></div>
{/if}
</form>`
};
}

Fez('calendar-answer', __fez_component_0);

export default __fez_component_0;
